import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "style-guide--colors" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", null, "Base Colors", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h4", null, "Primary", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "box base-color-primary-pure" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("code", null, "$base-color-primary-pure", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "box base-color-primary-lt" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("code", null, "$base-color-primary-lt", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "box base-color-primary-xmed" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("code", null, "$base-color-primary-xmed", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "box base-color-primary-med" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("code", null, "$base-color-primary-med", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "box base-color-primary-dark" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("code", null, "$base-color-primary-dark", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h4", null, "Secondary", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "box base-color-secondary-pure" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("code", null, "$base-color-secondary-pure", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "box base-color-secondary-med" }, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("code", null, "$base-color-secondary-med", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "box base-color-secondary-dark" }, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("code", null, "$base-color-secondary-dark", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("h3", null, "Accent Colors", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "box accent-color-pure" }, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("code", null, "$accent-color-pure", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "box accent-color-lt" }, null, -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("code", null, "$accent-color-lt", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "box accent-color-med" }, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("code", null, "$accent-color-med", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "box accent-color-dark" }, null, -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("code", null, "$accent-color-dark", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("h3", null, "Neutral Colors", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("h4", null, "Low", -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "box neutral-color-low-pure" }, null, -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("code", null, "$neutral-color-low-pure", -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "box neutral-color-low-lt" }, null, -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("code", null, "$neutral-color-low-lt", -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "box neutral-color-low-med" }, null, -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("code", null, "$neutral-color-low-med", -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "box neutral-color-low-dark" }, null, -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("code", null, "$neutral-color-low-dark", -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("h4", null, "High", -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "box neutral-color-high-pure" }, null, -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("code", null, "$neutral-color-high-pure", -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "box neutral-color-high-xlt" }, null, -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("code", null, "$neutral-color-high-xlt", -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "box neutral-color-high-lt" }, null, -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("code", null, "$neutral-color-high-lt", -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "box neutral-color-high-med" }, null, -1)
const _hoisted_48 = /*#__PURE__*/_createElementVNode("code", null, "$neutral-color-high-med", -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { class: "box neutral-color-high-dark" }, null, -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("code", null, "$neutral-color-high-dark", -1)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("h3", null, "Background Colors", -1)
const _hoisted_52 = /*#__PURE__*/_createElementVNode("h4", null, "Low", -1)
const _hoisted_53 = /*#__PURE__*/_createElementVNode("div", { class: "box bg-color-low-pure" }, null, -1)
const _hoisted_54 = /*#__PURE__*/_createElementVNode("code", null, "$bg-color-low-pure", -1)
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", { class: "box bg-color-low-xlt" }, null, -1)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("code", null, "$bg-color-low-xlt", -1)
const _hoisted_57 = /*#__PURE__*/_createElementVNode("div", { class: "box bg-color-low-lt" }, null, -1)
const _hoisted_58 = /*#__PURE__*/_createElementVNode("code", null, "$bg-color-low-lt", -1)
const _hoisted_59 = /*#__PURE__*/_createElementVNode("div", { class: "box bg-color-low-xmed" }, null, -1)
const _hoisted_60 = /*#__PURE__*/_createElementVNode("code", null, "$bg-color-low-xmed", -1)
const _hoisted_61 = /*#__PURE__*/_createElementVNode("div", { class: "box bg-color-low-med" }, null, -1)
const _hoisted_62 = /*#__PURE__*/_createElementVNode("code", null, "$bg-color-low-med", -1)
const _hoisted_63 = /*#__PURE__*/_createElementVNode("div", { class: "box bg-color-low-dark" }, null, -1)
const _hoisted_64 = /*#__PURE__*/_createElementVNode("code", null, "$bg-color-low-dark", -1)
const _hoisted_65 = /*#__PURE__*/_createElementVNode("h4", null, "High", -1)
const _hoisted_66 = /*#__PURE__*/_createElementVNode("div", { class: "box bg-color-high-pure" }, null, -1)
const _hoisted_67 = /*#__PURE__*/_createElementVNode("code", null, "$bg-color-high-pure", -1)
const _hoisted_68 = /*#__PURE__*/_createElementVNode("div", { class: "box bg-color-high-xlt" }, null, -1)
const _hoisted_69 = /*#__PURE__*/_createElementVNode("code", null, "$bg-color-high-xlt", -1)
const _hoisted_70 = /*#__PURE__*/_createElementVNode("div", { class: "box bg-color-high-lt" }, null, -1)
const _hoisted_71 = /*#__PURE__*/_createElementVNode("code", null, "$bg-color-high-lt", -1)
const _hoisted_72 = /*#__PURE__*/_createElementVNode("div", { class: "box bg-color-high-med" }, null, -1)
const _hoisted_73 = /*#__PURE__*/_createElementVNode("code", null, "$bg-color-high-med", -1)
const _hoisted_74 = /*#__PURE__*/_createElementVNode("div", { class: "box bg-color-high-dark" }, null, -1)
const _hoisted_75 = /*#__PURE__*/_createElementVNode("code", null, "$bg-color-high-dark", -1)
const _hoisted_76 = /*#__PURE__*/_createElementVNode("h3", null, "Feedback Colors", -1)
const _hoisted_77 = /*#__PURE__*/_createElementVNode("h4", null, "Warning", -1)
const _hoisted_78 = /*#__PURE__*/_createElementVNode("div", { class: "box feedback-color-warning-pure" }, null, -1)
const _hoisted_79 = /*#__PURE__*/_createElementVNode("code", null, "$feedback-color-warning-pure", -1)
const _hoisted_80 = /*#__PURE__*/_createElementVNode("div", { class: "box feedback-color-warning-lt" }, null, -1)
const _hoisted_81 = /*#__PURE__*/_createElementVNode("code", null, "$feedback-color-warning-lt", -1)
const _hoisted_82 = /*#__PURE__*/_createElementVNode("div", { class: "box feedback-color-warning-dark" }, null, -1)
const _hoisted_83 = /*#__PURE__*/_createElementVNode("code", null, "$feedback-color-warning-dark", -1)
const _hoisted_84 = /*#__PURE__*/_createElementVNode("h4", null, "Alert", -1)
const _hoisted_85 = /*#__PURE__*/_createElementVNode("div", { class: "box feedback-color-alert-pure" }, null, -1)
const _hoisted_86 = /*#__PURE__*/_createElementVNode("code", null, "$feedback-color-alert-pure", -1)
const _hoisted_87 = /*#__PURE__*/_createElementVNode("div", { class: "box feedback-color-alert-lt" }, null, -1)
const _hoisted_88 = /*#__PURE__*/_createElementVNode("code", null, "$feedback-color-alert-lt", -1)
const _hoisted_89 = /*#__PURE__*/_createElementVNode("div", { class: "box feedback-color-alert-med" }, null, -1)
const _hoisted_90 = /*#__PURE__*/_createElementVNode("code", null, "$feedback-color-alert-med", -1)
const _hoisted_91 = /*#__PURE__*/_createElementVNode("div", { class: "box feedback-color-alert-dark" }, null, -1)
const _hoisted_92 = /*#__PURE__*/_createElementVNode("code", null, "$feedback-color-alert-dark", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "12" }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { cols: "12" }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { cols: "12" }, {
          default: _withCtx(() => [
            _hoisted_4,
            _hoisted_5
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { cols: "12" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, {
              class: "color-variants",
              justify: "start"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, null, {
                  default: _withCtx(() => [
                    _hoisted_6,
                    _hoisted_7
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, null, {
                  default: _withCtx(() => [
                    _hoisted_8,
                    _hoisted_9
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, null, {
                  default: _withCtx(() => [
                    _hoisted_10,
                    _hoisted_11
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, null, {
                  default: _withCtx(() => [
                    _hoisted_12,
                    _hoisted_13
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { cols: "12" }, {
          default: _withCtx(() => [
            _hoisted_14
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { cols: "12" }, {
          default: _withCtx(() => [
            _hoisted_15,
            _hoisted_16
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { cols: "12" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, {
              class: "color-variants",
              justify: "start"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, null, {
                  default: _withCtx(() => [
                    _hoisted_17,
                    _hoisted_18
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, null, {
                  default: _withCtx(() => [
                    _hoisted_19,
                    _hoisted_20
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "12" }, {
          default: _withCtx(() => [
            _hoisted_21
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { cols: "12" }, {
          default: _withCtx(() => [
            _hoisted_22,
            _hoisted_23
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { cols: "12" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, {
              class: "color-variants",
              justify: "start"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, null, {
                  default: _withCtx(() => [
                    _hoisted_24,
                    _hoisted_25
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, null, {
                  default: _withCtx(() => [
                    _hoisted_26,
                    _hoisted_27
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, null, {
                  default: _withCtx(() => [
                    _hoisted_28,
                    _hoisted_29
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "12" }, {
          default: _withCtx(() => [
            _hoisted_30
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { cols: "12" }, {
          default: _withCtx(() => [
            _hoisted_31
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { cols: "12" }, {
          default: _withCtx(() => [
            _hoisted_32,
            _hoisted_33
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { cols: "12" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, {
              class: "color-variants",
              justify: "start"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, null, {
                  default: _withCtx(() => [
                    _hoisted_34,
                    _hoisted_35
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, null, {
                  default: _withCtx(() => [
                    _hoisted_36,
                    _hoisted_37
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, null, {
                  default: _withCtx(() => [
                    _hoisted_38,
                    _hoisted_39
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { cols: "12" }, {
          default: _withCtx(() => [
            _hoisted_40
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { cols: "12" }, {
          default: _withCtx(() => [
            _hoisted_41,
            _hoisted_42
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { cols: "12" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, {
              class: "color-variants",
              justify: "start"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, null, {
                  default: _withCtx(() => [
                    _hoisted_43,
                    _hoisted_44
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, null, {
                  default: _withCtx(() => [
                    _hoisted_45,
                    _hoisted_46
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, null, {
                  default: _withCtx(() => [
                    _hoisted_47,
                    _hoisted_48
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, null, {
                  default: _withCtx(() => [
                    _hoisted_49,
                    _hoisted_50
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "12" }, {
          default: _withCtx(() => [
            _hoisted_51
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { cols: "12" }, {
          default: _withCtx(() => [
            _hoisted_52
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { cols: "12" }, {
          default: _withCtx(() => [
            _hoisted_53,
            _hoisted_54
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { cols: "12" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, {
              class: "color-variants",
              justify: "start"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, null, {
                  default: _withCtx(() => [
                    _hoisted_55,
                    _hoisted_56
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, null, {
                  default: _withCtx(() => [
                    _hoisted_57,
                    _hoisted_58
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, null, {
                  default: _withCtx(() => [
                    _hoisted_59,
                    _hoisted_60
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, null, {
                  default: _withCtx(() => [
                    _hoisted_61,
                    _hoisted_62
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, null, {
                  default: _withCtx(() => [
                    _hoisted_63,
                    _hoisted_64
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { cols: "12" }, {
          default: _withCtx(() => [
            _hoisted_65
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { cols: "12" }, {
          default: _withCtx(() => [
            _hoisted_66,
            _hoisted_67
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { cols: "12" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, {
              class: "color-variants",
              justify: "start"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, null, {
                  default: _withCtx(() => [
                    _hoisted_68,
                    _hoisted_69
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, null, {
                  default: _withCtx(() => [
                    _hoisted_70,
                    _hoisted_71
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, null, {
                  default: _withCtx(() => [
                    _hoisted_72,
                    _hoisted_73
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, null, {
                  default: _withCtx(() => [
                    _hoisted_74,
                    _hoisted_75
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "12" }, {
          default: _withCtx(() => [
            _hoisted_76
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { cols: "12" }, {
          default: _withCtx(() => [
            _hoisted_77
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { cols: "12" }, {
          default: _withCtx(() => [
            _hoisted_78,
            _hoisted_79
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { cols: "12" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, {
              class: "color-variants",
              justify: "start"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, null, {
                  default: _withCtx(() => [
                    _hoisted_80,
                    _hoisted_81
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, null, {
                  default: _withCtx(() => [
                    _hoisted_82,
                    _hoisted_83
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { cols: "12" }, {
          default: _withCtx(() => [
            _hoisted_84
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { cols: "12" }, {
          default: _withCtx(() => [
            _hoisted_85,
            _hoisted_86
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { cols: "12" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, {
              class: "color-variants",
              justify: "start"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, null, {
                  default: _withCtx(() => [
                    _hoisted_87,
                    _hoisted_88
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, null, {
                  default: _withCtx(() => [
                    _hoisted_89,
                    _hoisted_90
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, null, {
                  default: _withCtx(() => [
                    _hoisted_91,
                    _hoisted_92
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}